import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  fetchAssociatedCompanyAssets,
  fetchCompanyId,
  fetchCompanyAssetsDetails,
  fetchPortfolioFundManager,
  fetchReferenceFundManager,
  fetchUpdateCompanyAssets,
  fetchUpdateFundManagerJson,
} from '../Slice/FundActions';

export const getCompanyAssetsDetails = createAsyncThunk(
  'companyAssets/getDetail',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } = await fetchCompanyAssetsDetails(requestObject);
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getCompanyID = createAsyncThunk(
  'fundmanager-page/getCompanyID',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } = await fetchCompanyId(requestObject);
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateCompanyAssetsDetails = createAsyncThunk(
  'companyAssets/updateDetails',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } = await fetchUpdateCompanyAssets(requestObject);
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateFundManagerJson = createAsyncThunk(
  'fundManager/updateJson',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } = await fetchUpdateFundManagerJson(requestObject);
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getAssociatedCompanyAssets = createAsyncThunk(
  'fundManager/getAssociatedCompanyAssets',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } =
        await fetchAssociatedCompanyAssets(requestObject);
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getReferencesFundManager = createAsyncThunk(
  'fundManager/getReferencesFundManager',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } = await fetchReferenceFundManager(requestObject);
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getPortfolioFundManager = createAsyncThunk(
  'fundManager/getPortfolioFundManager',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } = await fetchPortfolioFundManager(requestObject);
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
